const QuestionMarkIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 11 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.8 12.104l2.615-.768c-.24-.216-.432-.624-.432-1.008 0-2.016 4.008-2.28 4.008-5.784C10.991 2.312 9.095.752 6 .752c-2.064 0-3.984.84-5.256 2.328l1.944 2.184c.744-.888 1.752-1.488 2.952-1.488 1.32 0 1.872.624 1.872 1.368 0 1.656-3.504 1.992-3.504 4.848 0 .84.288 1.56.792 2.112zm1.151 5.16a1.967 1.967 0 001.944-1.944 1.967 1.967 0 00-1.944-1.944 1.967 1.967 0 00-1.944 1.944c0 1.056.888 1.944 1.944 1.944z"
        fill="currentColor"
      />
    </svg>
  )
}

export default QuestionMarkIcon
